import type { EnderecoDoCep } from '@/comuns/cep';
import type { FichaDoPaciente } from '@/data/tipos';

export type CampoDoEndereco = 'rua' | 'bairro' | 'cidade' | 'estado';

/**
 * O que o CEP pode preencher na ficha do paciente — só o que está VAZIO.
 *
 * O mesmo critério de `completarEndereco` na unidade: o que a recepção já digitou
 * não é trocado pelo que o ViaCEP acha. Na ficha cada campo se salva sozinho, então
 * a resposta é a lista de campos a gravar, e não um formulário novo.
 */
export function camposPeloCep(
    ficha: Pick<FichaDoPaciente, CampoDoEndereco>,
    doCep: EnderecoDoCep,
): { campo: CampoDoEndereco; valor: string }[] {
    const campos: CampoDoEndereco[] = ['rua', 'bairro', 'cidade', 'estado'];
    return campos
        .filter((campo) => !String(ficha[campo] ?? '').trim() && doCep[campo].trim())
        .map((campo) => ({ campo, valor: doCep[campo] }));
}
